import ExpandableWithToggle from "../../../../../components/BasicComponents/ExpandableWithToggle";
import CustomizeComp from "../../Aside2Components/CustomizeComp";

const ContainerWithOutToggle = (props) => {
  const { ControllerProps, currentSheet, dispatchItemToredux } = props;
  const { title, reduxKey, innerComponents, defaultValue } = ControllerProps;
  console.log(dispatchItemToredux);

  return (
    <>
      <main className="flex items-start justify-start w-full">
        <ExpandableWithToggle
          ControllerProps={ControllerProps}
          currentSheet={currentSheet}
          dispatchItemToredux={dispatchItemToredux}
          defaultValue={defaultValue}
          componentType="CONTAINER_WITHOUT_TOGGLE"
        >
          {innerComponents.map((Controller, i) => (
            <CustomizeComp
              key={i}
              ControllerProps={Controller}
              parentKey="customization"
              currentSheet={currentSheet}
            />
          ))}
        </ExpandableWithToggle>
      </main>
    </>
  );
};
export { ContainerWithOutToggle };
